import { useMutation } from "@tanstack/react-query";
import api from "../../utils/api";
import { useInvalidateDomain } from "../../lib/invalidation";

export interface UpdateUserBody {
  userID: string;
  user: Record<string, unknown>;
}

function useInvalidateUsers() {
  const invalidateDomain = useInvalidateDomain();
  return () => invalidateDomain("users");
}

export function useCreateUser() {
  const invalidate = useInvalidateUsers();
  return useMutation({
    mutationFn: (body: Record<string, unknown>) =>
      api.post("/user", body, { timeout: 60000 }).then((res) => res.data),
    onSuccess: invalidate,
  });
}

export function useUpdateUser() {
  const invalidate = useInvalidateUsers();
  return useMutation({
    mutationFn: (body: UpdateUserBody) =>
      api.put("/user", body, { timeout: 60000 }).then((res) => res.data),
    onSuccess: invalidate,
  });
}

export function useDeleteUser() {
  const invalidate = useInvalidateUsers();
  return useMutation({
    mutationFn: (userID: string) =>
      api
        .delete("/user", { data: { userID }, timeout: 60000 })
        .then((res) => res.data),
    onSuccess: invalidate,
  });
}
